window.BlockCounter = (target) => {
    return {
        start: 0,
        current: 0,
        target: target,
        time: 1000,
        countStarted: false,
        initCounter() {
      
            const countWhenInView = new IntersectionObserver((entries) => {
                if (entries[0].isIntersecting) {
                    this.count();
                }
            });
            
            countWhenInView.observe(this.$el);

        },
        count() {
            if(!this.countStarted) {
                this.countStarted = true;
                let start = this.current; 
                const interval = Math.max(this.time / (this.target - start), 5); 
                const step = (this.target - start) /  (this.time / interval);  
                const handle = setInterval(() => {
                    if(this.current < this.target) 
                        this.current += step
                    else {
                        clearInterval(handle);
                        this.current = this.target
                    }   
                    }, interval)
            }
                
        },
    }
}


// WEBPACK FOOTER //
// ./scripts/blocks/Counter.js